import React from 'react';
import PropTypes from 'prop-types';
import sanitize from '../Wrappers/SanitizeHtml';
import { validacionDePrecio } from '../../../Helpers/Precio';
import Text from '../../Common/Text/Text';
import Icon from '../../Common/Atoms/Icon';

const propTypes = {
    cantCredenciales: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    features: PropTypes.array.isRequired,
    precio: PropTypes.number.isRequired,
    cantidadDeMeses: PropTypes.number,
    precioFinal: PropTypes.number,
};

function ComboPlan(props) {
    const { cantCredenciales, titulo, precio, features, cantidadDeMeses = null, precioFinal = null } = props;

    const validacionDeMeses = (cantidadDeMeses, precioFinal) => {
        return (
            <>
                <div className="texto-meses --mt-16 --mb-4">
                    <Text tag="p" size="6xs" className="--roboto texto">
                        <strong>DURANTE {cantidadDeMeses} MESES</strong>
                    </Text>
                </div>
                <Text tag="p" size="6xs" className="--roboto --mb-16">
                    luego ${precioFinal} por mes
                </Text>
            </>
        );
    };

    const loadFeatures = (features) => {
        return features.map((feature, index) => {
            return (
                <div className="combo">
                    <Icon name="check-mark" size="4xs" />
                    <p key={index} className="item-plan" dangerouslySetInnerHTML={sanitize(feature)}></p>
                </div>
            );
        });
    };

    return (
        <div className="caja-plan">
            <div className="datos-plan --sueca">
                <div className="arrow-down"></div>

                <p className="titulo-plan --sueca">
                    <b>{titulo}</b>
                </p>

                {loadFeatures(features)}

                {cantidadDeMeses == null && <div className="--mb-32"></div>}

                <p className="precio-plan --sueca">
                    $<label>{validacionDePrecio(precio)}</label>/mes
                </p>

                {cantidadDeMeses != null && validacionDeMeses(cantidadDeMeses, precioFinal)}
            </div>
        </div>
    );
}

ComboPlan.propTypes = propTypes;

export default ComboPlan;
